<template>
    <div v-if="loadingVitrinesOnly" class="over container">
        <div class="row" style="height: 45vh">
            <div class="col-12"></div>
        </div>
        <div class="row">
            <div class="spinner-border text-primary center" role="status">
                <span class="sr-only"></span>
            </div>
        </div>
    </div>

    <div v-else-if="vitrineArrayOnly.length > 0" class="mt-0 background" style="font-family: 'segoeui' !important;" >
        <div>
            <PointNumberLine class="m-0" :class="{ ltr: isEnglish }" :point-number="pointNumber" />
            <div class="p-3 myModal row" style="font-size: 20px; min-height: 95vh; width: 93%" v-if="showMainPage">
                <!-- <hr v-if="pointNumber != 0" /> -->
                <!-- <div class="row mb-4" v-if="pointNumber > 0"> -->
                <div class="row mb-4">
                    <div class="col-12 text-center startHere" v-if="pointNumber == 0">
                        {{ lang }}        {{ translation.startTour }}
                    </div>
                    <div class="col-12 text-center vitrineTitle">
                        {{ vitrineArrayOnly[pointNumber]?.itemName }}
                    </div>
                </div>
                <!-- <hr v-if="pointNumber != 0" /> -->
                <!-- <div v-else class="mt-3"></div> -->
                <div class="imageDiv" @click="openMoreInformation">
                    <img v-if="vitrineArrayOnly[pointNumber]" ref="mainImage" :src="vitrineArrayOnly[pointNumber].imageBase64"
                        alt="" class="imageMain" />
                </div>
                <div class="mt-3" style="position: relative; height: 60px">
                    <!-- backward arrow — fixed to right edge of screen -->
                    <div class="arrowFixed arrowRight" v-if="pointNumber > 0" @click="pointLess">
                        <button class="buttonWhiteBorder buttonAdults btn" :class="{ noBold: isEnglish }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" fill="currentColor"
                                class="bi bi-arrow-right-short" viewBox="0 0 16 16"
                                style="left: 10px; position: relative">
                                <path fill-rule="evenodd"
                                    d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                            </svg>
                        </button>
                    </div>
                    <!-- info button — centered in the card, hidden when the vitrine has no items -->
                    <div class="buttonsAndArrows text-center" v-if="hasItems"
                        @click="openMoreInformation">
                        <button class="roundButton">
                            {{ lang }}        {{ translation.aboutItems }}
                        </button>
                    </div>
                    <!-- forward arrow — fixed to left edge of screen -->
                    <div class="arrowFixed arrowLeft" @click="pointPlus"
                        v-if="Number(pointNumber) + 1 < vitrineArrayOnly.length - 1">
                        <button class="buttonWhiteBorder buttonChildren btn" :class="{ noBold: isEnglish }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" fill="currentColor"
                                class="bi bi-arrow-left-short" viewBox="0 0 16 16"
                                style="left: 8px; position: relative">
                                <path fill-rule="evenodd"
                                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div v-if="pointNumber == 0" class="row my-3">
                    <div class="text-center col-4 p-0"></div>
                    <div class="text-center col-4 p-0"></div>
                </div>
                <!-- <audio v-if="vitrineArrayOnly[pointNumber] && showAudio" ref="audio" :key="keyToReRenderAudio" controls -->
                <audio v-if="vitrineArrayOnly[pointNumber] && vitrineArrayOnly[pointNumber].audioUrl && vitrineArrayOnly[pointNumber].audioUrl != '' && $store.getters.lang == 'he'" ref="audio" :key="keyToReRenderAudio" controls

                    class="mt-3 audioButton">
                    <source :src="vitrineArrayOnly[pointNumber].audioUrl" type="audio/mp3" />
                </audio>
                <div :class="{ ltr: isEnglish }">
                    <div v-if="vitrineArrayOnly[pointNumber]" class="row mb-3 p-3" ref="informationDiv"
                        style="position: relative">
                        <div class="text-end col-12 ps-0" style="white-space: pre-line; font-size: 18px" :class="{ ltr: isEnglish }">
                            {{ vitrineArrayOnly[pointNumber].pointInformation }}
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
// import Map from "./map";
import PointNumberLine from "./pointNumberLine";

export default {
    props: ["pointNumberBACK"],
    components: {
        PointNumberLine,
    },
    data() {
        return {
            englishLtr: false,
            isEnglish: false,
            showAudio: true,
            showMainPage: true,
            style: "",
            showSpecificInfo: false,
            infoToShow: "",
            imageToShow: "",
            periodToShow: "",
            placeToShow: "",
            nameToShow: "",
            materialToShow: "",
            showMoreInfoOfItem: false,
            keyToReRenderAudio: 0,
            showMoreInformation: false,
            index: 0,
            pointNumber: 0,
            hasItems: true,
            translation: {
                startTour: "הסיור מתחיל בחלון התצוגה המופיע בתמונה",
                aboutItems: "מידע על מוצגים",
                  }
        };
    },
    mounted() {
        if (!localStorage.getItem("vitrineOnlyArray")) {
            this.$store.dispatch("fetchVitrinesOnly", {
                navigationName: "visitMuseumEinDor",
            });
        } else {
            console.log("VITRINE ONLY ARRAY EXISTE DEJA");
        }

        if (localStorage.getItem("pointNumber")) {
            console.log("[mounted] pointNumber", this.pointNumber);
            console.log("[mounted] localStorage.getItem(pointNumber)", JSON.parse(localStorage.getItem("pointNumber")));

            this.pointNumber = JSON.parse(localStorage.getItem("pointNumber"));
        } else {
            this.pointNumber = 0;
            localStorage.setItem("pointNumber", 0);
        }
        if (this.$store.getters.lang == "en") {
            console.log("isEnglish")
            this.isEnglish = true
        }
    },
    watch: {
        pointNumber: {
            immediate: true,
            handler() {
                this.checkCurrentVitrineHasItems();
            }
        },
        vitrineArrayOnly() {
            this.checkCurrentVitrineHasItems();
        }
    },
    computed: {
        lang() {
          return this.translate(this.$store.getters.lang);
        },
        loading() {
            return this.$store.getters.loading;
        },
        loadingVitrinesOnly() {
            // console.log(
            //   "this.$store.getters.loadingVitrinesOnly",
            //   this.$store.getters.loadingVitrinesOnly
            // );
            return this.$store.getters.loadingVitrinesOnly;
        },
        error() {
            return this.$store.getters.error;
        },
        points() {
            // console.log("this.$store.getters.points", this.$store.getters.points);
            return this.$store.getters.points;
        },
        vitrineOrder() {
            return this.$store.getters.vitrineOrder;
        },
        // firstPoint() {
        //   console.log(
        //     "this.$store.getters.firstPoint",
        //     this.$store.getters.firstPoint
        //   );
        //   return this.$store.getters.firstPoint;
        // },
        vitrineArrayOnly() {
                        console.log("this.$store.getters.vitrineArrayOnly", this.$store.getters.vitrineArrayOnly);

            return this.$store.getters.vitrineArrayOnly;
        },

        itemsArray() {
            let itemsArray = [];
            this.points.forEach((point) => {
                if (point.vitrine == Number(this.pointNumber) + 1) {
                    itemsArray.push(point);
                }
            });
            console.log("itemsArray", itemsArray);
            return itemsArray;
        },
    },
    methods: {
        checkCurrentVitrineHasItems() {
            const currentVitrine = this.vitrineArrayOnly[this.pointNumber];
            if (!currentVitrine) return;
            this.$store.dispatch("checkVitrineHasItems", currentVitrine.pointNumber)
                .then(exists => { this.hasItems = exists; });
        },
        translate(lang) {
            switch (lang) {
                case 'he':
                this.translation = {
                    startTour: "הסיור מתחיל בחלון התצוגה המופיע בתמונה",
                    aboutItems: "מידע על מוצגים",
                                 }
                    break;
                case 'ar':
                this.translation = {
                    startTour: "تبدأ الجولة في نافذة العرض الموضحة في الصورة",
                    aboutItems: "معلومات عن كل غرض",
                    }
                    break;
                case 'en':
                this.translation = {
                    startTour: "The tour start at the window shown below",
                    aboutItems: "More info",
                         }
                    break;
                default:

            }
        },
        closeSpeciticInfo() {
            if (this.pointNumber == 0) {
                setTimeout(() => {
                    this.showMoreInformation = false;
                    this.showSpecificInfo = false;
                }, 900);
                document.getElementById("specificInfoPage").className = "fadeOut over";
                console.log("index0");
            } else {
                setTimeout(() => {
                    this.showMoreInformation = true;
                    this.showSpecificInfo = false;
                }, 1000);
                document.getElementById("specificInfoPage").className = "fadeOut over";
                this.showMoreInformation = true;
            }
        },
        fadeOutMoreInfo() {
            setTimeout(() => {
                this.showMoreInformation = false;
            }, 1000);
            document.getElementById("moreInfo").className = "fadeOut over";
            this.showMainPage = true;
        },
        openMoreInformation() {
            console.log("this.pointNumber", this.pointNumber)

            if (!this.hasItems) return;

            setTimeout(() => {
                localStorage.setItem("pointNumberFromVitrineMain", Number(this.vitrineArrayOnly[this.pointNumber].pointNumber));
                this.$router.push({
                    name: "itemsList",
                    params: { pointNumber: Number(this.vitrineArrayOnly[this.pointNumber].pointNumber) + 1 },
                });
            }, 500)

            // this.showMoreInformation = true;
            // this.showMainPage = false;
            // GOT RID OF THIS ONLY  BECAUSE THE AUDIO IS NOT READY*********************
            // this.$refs.audio.pause();
            // this.$refs.audio.currentTime = 0;

        },
        pointPlus() {
            // GOT RID OF THIS ONLY  BECAUSE THE AUDIO IS NOT READY*********************
            // this.$refs.audio.currentTime = 0;
            // this.$refs.audio.className = "slideRight audioButton mt-3";

            // this.$refs.informationDiv.scrollTo(0, 0);
            this.$refs.informationDiv.className = "slideRight";
            this.$refs.mainImage.className = "slideRight";
            setTimeout(() => {
                this.keyToReRenderAudio++;
                this.pointNumber++;
                localStorage.setItem("pointNumber", this.pointNumber);
                localStorage.setItem(
                    "listTitle",
                    this.vitrineArrayOnly[this.pointNumber].itemName
                );

                this.$refs.mainImage.className = "fadeIn";
                // this.$refs.audio.className = "fadeIn audioButton mt-3";
                this.$refs.informationDiv.className = "fadeIn";
            }, 300);
        },
        pointLess() {
            this.$refs.informationDiv.scrollTo(0, 0);
            this.$refs.mainImage.className = "slideLeft";
            // this.$refs.audio.className = "slideLeft audioButton mt-3 ";
            this.$refs.informationDiv.className = "slideLeft";
            setTimeout(() => {
                this.keyToReRenderAudio--;
                this.pointNumber--;
                localStorage.setItem(
                    "listTitle",
                    this.vitrineArrayOnly[this.pointNumber].itemName
                );
                localStorage.setItem("pointNumber", this.pointNumber);
                this.$refs.informationDiv.className = "fadeIn";
                // this.$refs.audio.className = "fadeIn audioButton mt-3";
                this.$refs.mainImage.className = "fadeIn";
            }, 300);
        },
        openImageInfo(name, imageUrl, material, period, place, info) {
            this.specificItemDetails = {
                infoToShow: info,
                imageToShow: imageUrl,
                periodToShow: period,
                placeToShow: place,
                materialToShow: material,
                nameToShow: name,
            };
            this.$router.push({
                name: "specificItemInfo",
                params: { specificItemDetails: this.specificItemDetails },
            });
        },

        onDismissed() {
            this.$store.dispatch("clearError");
        },
    },
};
</script>

<style scoped>
.alignRight {
    text-align: right;
}
.ltr {
    direction: ltr;
    text-align: left !important;
}

.imageDiv {
    direction: ltr;
    height: 270px;
    overflow: hidden;
    display: flex;
    justify-content: center;
}

.imageMain {
    height: 100%;
    position: relative;

}

.vitrineTitle {
    color: #63C4C3;
    font-size: 25px;
    font-weight: bold;
}

.startHere {
    color: #63C4C3;
    font-size: 15px;
    font-weight: bold;
}

.buttonWhiteBorder {
    color: white;
    font-size: 23px;
    border: solid 16px white;
    background-color: #63C4C3;
    height: 103px;
    box-shadow: -2px 7px 10px grey;
    width: 82px;
}

.buttonWhiteBorder:active,
.buttonWhiteBorder:focus {
    background-color: #63C4C3 !important;
    color: white !important;
    outline: none;
    box-shadow: -2px 7px 10px grey;
}

.buttonAdults {

    border-top-left-radius: 62px;
    border-bottom-left-radius: 62px;
    border-right: none;
}

.buttonChildren {
    border-top-right-radius: 62px;
    border-bottom-right-radius: 62px;
    border-left: none;

}

.buttonsAndArrows {
    position: relative;
    bottom: 77px;
    text-align: center;
}

.arrowFixed {
    position: fixed;
    top: 290px;
    z-index: 50;
}

.arrowRight {
    right: 0;
}

.arrowLeft {
    left: 0;
}

.captionArrow {
    position: absolute;
    font-size: 12px;
    top: 23px;
    left: 30px;
}

.audioButton {
    width: 100%;
    border: 2px #63C4C3 solid;
    border-radius: 25px;
    height: 40px;
    margin-bottom: 16px;
    position: relative;
}

.slideLeft {
    -webkit-animation: slideLeft 0.5s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: slideLeft 0.5s;
    /* Firefox < 16 */
    -ms-animation: slideLeft 0.5s;
    /* Internet Explorer */
    -o-animation: slideLeft 0.5s;
    /* Opera < 12.1 */
    animation: slideLeft 0.5s;
}

.slideRight {
    -webkit-animation: slideRight 0.5s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: slideRight 0.5s;
    /* Firefox < 16 */
    -ms-animation: slideRight 0.5s;
    /* Internet Explorer */
    -o-animation: slideRight 0.5s;
    /* Opera < 12.1 */
    animation: slideRight 0.5s;
}

.navBarTitle {
    position: relative;
    font-size: 22px !important;
    color: black;
    text-align: left;
    width: 100%;
    padding: 10px 18px;
}

.appBackground {
    background: url(../../static/img/appBackground.png) center center;
}

.titleSpan {
    z-index: 30;
    opacity: 1;
    padding: 10px;
    border: solid 1px white;
    width: 180px;
}

.backgroundImage {
    position: relative;
    text-align: center;
    color: white;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.backgroundImage::before {
    content: "";
    position: absolute;
    background-color: black;
    background-blend-mode: screen;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.5;
}

.closingCross {
    position: absolute;
    top: -45px;
    right: 16px;
    z-index: 20;
    color: black;
    font-size: 24px;
}

.detectiveName {
    position: relative;
    bottom: 189px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    display: block;
}

.licenceImage {
    width: 100%;
}

.fadeIn {
    -webkit-animation: fadein 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 1s;
    /* Firefox < 16 */
    -ms-animation: fadein 1s;
    /* Internet Explorer */
    -o-animation: fadein 1s;
    /* Opera < 12.1 */
    animation: fadein 1s;
}

.fadeOut {
    -webkit-animation: fadeOut 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadeOut 1s;
    /* Firefox < 16 */
    -ms-animation: fadeOut 1s;
    /* Internet Explorer */
    -o-animation: fadeOut 1s;
    /* Opera < 12.1 */
    animation: fadeOut 1s;
}

@font-face {
    font-family: segoeui;
    src: url(../../static/segoeui/segoeui.ttf);
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Internet Explorer */
@-ms-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Firefox < 16 */
@-moz-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideRight {
    from {
        left: 1;
    }

    to {
        left: 100vw;
    }
}

/* Internet Explorer */
@-ms-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

/* Opera < 12.1 */
@-o-keyframes slideRight {
    from {
        left: 0;
    }

    to {
        left: 100vw;
    }
}

@keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Firefox < 16 */
@-moz-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Internet Explorer */
@-ms-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

/* Opera < 12.1 */
@-o-keyframes slideLeft {
    from {
        left: 0;
    }

    to {
        left: -100vw;
    }
}

.imageInput {
    width: 100%;
}

.inputOnImage {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 5px;
    left: 5px;
    text-align: center;
}

.topSecret {
    position: absolute;
    bottom: -30px;
    left: -37px;
    width: 248px;
}

/* .roundButton {
  position: relative;
  height: 48px !important;
  width: 150px;
  border: black solid 1px;
  color: black;
  border-radius: 5px;
  background: white;
  font-size: 18px;
  box-shadow: 8px 13px 11px #888888;
} */
.roundButton {
    position: relative;
    height: 39px !important;
    max-width: 200px;
    width: 100%;
    border-radius: 35px;
    background: #F5F5F5;
    font-size: 20px;
    font-weight: bold;
    -webkit-box-shadow: 8px 13px 11px #888888;
    box-shadow: 1px 10px 10px #c5c3c3;
    color: #63C4C3;
    border: none;
    top: 48px;
}

.roundButton:active {
    top: 55px;
    /* border: black solid 1px !important; */
    border: none;

}

.inputSecretCode {
    width: 40px;
}

.stopButton {
    border-radius: 10px;
    background-color: rgb(183 26 5);
    margin-top: 30px;
    font-size: 24px;
    height: 50px;
    width: 50px;
    border: solid 2px white;
}

.recButton {
    border-radius: 50px;
    background-color: rgb(183 26 5);
    margin-top: 30px;
    font-size: 24px;
    height: 50px;
    width: 50px;
    border: solid 15px white;
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        border: solid 10px white;
    }
}

.green {
    border: solid 5px #05e01c !important;
}

.image {
    width: 100%;
}

#timer {
    height: 62px;
    background: brown;
    padding-top: 11px;
    color: white;
    margin: 0;
}

.background {
    background-color: white;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.myModal {
    width: 320px;
    border-radius: 10px;
    display: block;
    margin: 0px auto;
    background-color: white;
}

.over {
    position: absolute;
    top: 50px;
    font-size: 18px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: block;
    margin: 0px auto;
    background: white;
}

.center {
    display: block;
    margin: 0px auto;
}

.colorBtn {
    border-radius: 36px;
    min-height: 56px;
    color: white;
}

.fullWidth {
    width: 95%;
    display: block;
    margin: 0px auto;
}

.container {
    margin-top: 16px;
    font-size: 20px;
    min-height: 100vh;
}</style>
